import React from 'react';
import { LayoutDashboardIcon, UsersIcon, CalendarCheckIcon, WrenchIcon, DollarSignIcon, TicketIcon, MessageSquareIcon, LogOutIcon } from 'lucide-react';
export const Sidebar = ({
  currentPage,
  onNavigate,
  onLogout
}) => {
  return <div className="w-64 bg-white border-r border-gray-200 hidden md:flex flex-col h-full" data-id="element-298">
      <div className="p-4 border-b border-gray-200" data-id="element-299">
        <div className="flex items-center" data-id="element-300">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4Kv3v8GHQWjwS3xkZwFMvx/pasted-image.png" alt="Real Estream" className="h-8" data-id="element-301" />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto py-4" data-id="element-302">
        <nav className="px-2" data-id="element-303">
          <SidebarItem icon={<LayoutDashboardIcon size={20} data-id="element-305" />} label="Dashboard" active={currentPage === 'dashboard'} onClick={() => onNavigate('dashboard')} data-id="element-304" />
          <SidebarItem icon={<UsersIcon size={20} data-id="element-307" />} label="Users" active={currentPage === 'users'} onClick={() => onNavigate('users')} data-id="element-306" />
          <SidebarItem icon={<CalendarCheckIcon size={20} data-id="element-309" />} label="Bookings" active={currentPage === 'bookings'} onClick={() => onNavigate('bookings')} data-id="element-308" />
          <SidebarItem icon={<WrenchIcon size={20} data-id="element-311" />} label="Services" active={currentPage === 'services'} onClick={() => onNavigate('services')} data-id="element-310" />
          <SidebarItem icon={<DollarSignIcon size={20} data-id="element-313" />} label="Financials" active={currentPage === 'financials'} onClick={() => onNavigate('financials')} data-id="element-312" />
          <SidebarItem icon={<TicketIcon size={20} data-id="element-315" />} label="Coupons" active={currentPage === 'coupons'} onClick={() => onNavigate('coupons')} data-id="element-314" />
          <SidebarItem icon={<MessageSquareIcon size={20} data-id="element-317" />} label="Support" active={currentPage === 'support'} onClick={() => onNavigate('support')} data-id="element-316" />
        </nav>
      </div>
      <div className="p-4 border-t border-gray-200" data-id="element-318">
        <SidebarItem icon={<LogOutIcon size={20} data-id="element-320" />} label="Logout" onClick={onLogout} data-id="element-319" />
      </div>
    </div>;
};
const SidebarItem = ({
  icon,
  label,
  active = false,
  onClick
}) => {
  return <div onClick={onClick} className={`flex items-center px-4 py-2.5 text-sm font-medium rounded-md mb-1 cursor-pointer ${active ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-321">
      <span className={`${active ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-322">
        {icon}
      </span>
      <span className="ml-3" data-id="element-323">{label}</span>
    </div>;
};